import { Wave } from "./Wave";

export const SectionTitle = ({ eyebrow, title, light = false, children }) => (
    <div className="max-w-2xl">
        <p className={`eyebrow ${light ? "eyebrow-light" : ""}`}>{eyebrow}</p>
        <h2 className="font-heading font-semibold uppercase tracking-wide text-3xl sm:text-4xl lg:text-5xl mt-2">
            {title}
        </h2>
        <Wave className="w-16 h-3 mt-4 text-ambra" />
        {children}
    </div>
);